import React, {Fragment} from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert,
    Row,
    Col,
    Label,
    FormFeedback,
    Input,
    FormText, Badge
} from 'reactstrap';

import {Utils} from "custom";
import {ClassroomIndividualAPI, ModuleAPI} from "api";
import Select from "react-select";
import logoTikTok from "../../../assets/images/logo-tiktok.png";
import Flatpickr from "react-flatpickr";
import {Italian} from "flatpickr/dist/l10n/it";

const moment = require("moment")

const chips = [
    { id: 'WAITING', label: 'In Attesa', color: 'warning' },
    { id: 'ACTIVE', label: 'Attiva', color: 'primary' }
];

class GestClassroomIndividual extends React.Component {
    constructor(props) {
        super(props);
        let preset = this.props.preset;

        this.state = {
            form: {
                teacher_id: preset.teacher_id,
                level_id: preset.level.id,
                date_start: preset.date_start,
                date_end: preset.date_end,
                hours: preset.hours ?? "",
                status: preset.status
            },
            loading: false,
            errors: false
        };
    }

    changeForm(key, text) {
        const form = this.state.form;

        if (key === "teacher_id") {
            form.teacher_id = text.value;
        }

        if (key === "hours") {
            if (isNaN(text))
                return;
        }

        if (key === "dates") {
            form.date_start = text.date_start;
            form.date_end = text.date_end;
        } else {
            form[key] = text;
        }

        this.setState({form: form}, () => this.showModal());
    }

    showModal() {

        let form = this.state.form;
        let errors = this.state.errors;

        global.onSetModal({
            title: "MODIFICA LEZIONE INDIVIDUALE",
            content: <div>
                <Row>
                    <Col>
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Durata Classe Individuale
                            </Label>
                            <div className="input-group">
                                <Flatpickr
                                    className="form-control border-0 dash-filter-picker shadow"
                                    options={{
                                        mode: "range",
                                        dateFormat: "d/m/Y",
                                        locale: Italian,
                                    }}
                                    value={(form.date_start && form.date_end) ? [moment(form.date_start).format("DD/MM/YYYY"), moment(form.date_end).format("DD/MM/YYYY")] : undefined}
                                    onChange={(selectedDates) => {
                                        if (selectedDates.length === 2) {
                                            this.changeForm('dates', {
                                                date_start: moment(selectedDates[0]),
                                                date_end: moment(selectedDates[1]),
                                            });
                                        }
                                    }}
                                />
                                <div
                                    className="input-group-text bg-primary border-primary text-white">
                                    <i className="ri-calendar-2-line"></i></div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <br />
                <Row hidden={Utils.getUserData().role === "TEACHER"}>
                    <Col>
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Docente Assegnato
                            </Label>
                            <Select
                                value={this.props.teachers.find((t) => t.value === form.teacher_id)}
                                options={this.props.teachers}
                                placeholder={"Seleziona Docente..."}
                                onChange={(val) => {
                                    this.changeForm('teacher_id', val)
                                }}
                            ></Select>
                            <Input invalid={Boolean(errors?.teacher_id)} hidden/>
                            <FormFeedback>{errors?.teacher_id}</FormFeedback>
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md="12">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Numero Ore
                            </Label>
                            <Input type="number" value={form.hours} disabled={Utils.getUserData().role === "TEACHER"}
                                   invalid={Boolean(errors.hours)}
                                   onChange={(e) => this.changeForm('hours', e.target.value)}/>
                            <FormFeedback>{errors.hours}</FormFeedback>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Livello
                            </Label>
                            <Input type="text" disabled value={this.props.preset.level.name}/>
                        </div>
                    </Col>
                </Row>
                <br />
                <br />
                <Row>
                    <Col md="12">
                        <Label className='form-label'>
                            Stato Classe Individuale
                        </Label>
                    </Col>
                    {/* Se la classe è già COMPLETED, mostro anche quel chip (in sola visualizzazione).
                        Il completamento effettivo si fa dalla pagina di dettaglio. */}
                    {(form.status === "COMPLETED"
                        ? [...chips, { id: 'COMPLETED', label: 'Completato', color: 'success' }]
                        : chips
                    ).map((chip) => (
                        <Col md="4" key={chip.id}>
                            <div className="mb-2 text-center">
                                <Button
                                    color={form.status === chip.id ? chip.color : 'light'}
                                    outline={form.status !== chip.id}
                                    onClick={() => this.changeForm('status', chip.id)}
                                    className={`rounded-pill px-4 py-2 border-${chip.color} text-${chip.color} ${
                                        form.status === chip.id ? 'text-white' : ''
                                    }`}
                                >
                                    {chip.label}
                                </Button>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>,
            isOpen: true,
            toggle: false,
            size: 'lg',
            type: 'info',
            buttons: [
                {label: 'SALVA', color: 'success', onClick: () => this.saveClassroom()},
                {
                    label: 'CHIUDI',
                    color: 'danger',
                    onClick: () => this.resetForm()
                }
            ]
        })
    }

    resetForm() {
        let preset = this.props.preset;

        this.setState({
            form: {
                teacher_id: preset.teacher_id,
                level_id: preset.level.id,
                date_start: preset.date_start,
                date_end: preset.date_end,
                hours: preset.hours ?? "",
                status: preset.status
            },
            loading: false,
            errors: false
        })
        global.onSetModal({isOpen: false, loading: false, content: ""})
    }

    saveClassroom() {
        const self = this;
        let form = this.state.form;
        let error = {};

        if (form.hours === "")
            error.hours = "Il campo ore è obbligatorio";

        this.setState({errors: error}, () => this.showModal());

        if (Object.keys(error).length === 0) {
            global.onSetModal({loading: true});

            if (moment(form.date_start).isValid() && moment(form.date_end).isValid()) {
                form.date_start = moment(form.date_start).format("YYYY-MM-DD");
                form.date_end = moment(form.date_end).format("YYYY-MM-DD");
            } else {
                form.date_start = null;
                form.date_end = null;
            }

            if (form.teacher_id?.value) {
                form.teacher_id = form.teacher_id.value
            }

            ClassroomIndividualAPI.edit(form, this.props.preset.id).then(() => {
                global.onSetModal({loading: false});
                global.SweetAlert.fire({
                    title: 'Lezione Individuale modificata',
                    text: 'La lezione individuale è stata modificata correttamente.',
                    icon: 'success',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    },
                    confirmButtonText: 'Chiudi',
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        self.resetForm();
                        self.props.onResolve();
                    }
                })
            }).catch((err) => {
                global.onSetModal({loading: false});
                global.SweetAlert.fire({
                    title: 'Errore',
                    text: 'Si è verificato un errore durante la modifica della lezione individuale',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    }
                });
            })
        }
    }


    render() {
        return (
            <React.Fragment>
                <li className="list-inline-item cursor-pointer" onClick={() => this.showModal()}>
                    <i className="ri-pencil-fill fs-20 text-info"></i>
                </li>
            </React.Fragment>
        )
    }
}

export default GestClassroomIndividual;
